import { Component, OnInit } from '@angular/core';
import {Constants} from '../../constants';
import {RulesService} from '../../rules.service';

@Component({
  selector: 'app-rule-preview',
  templateUrl: './rule-preview.component.html',
  styleUrls: ['./rule-preview.component.scss']
})
export class RulePreviewComponent implements OnInit {

  constructor(private ruleService: RulesService) { }

  ngOnInit() {
  }

  get tokens() {
    let tokens = [];
    if (!this.ruleService.rows.length) {
      return tokens;
    }
    const rowLength = this.ruleService.rows.length - 1;
    this.ruleService.rows.forEach((row, index) => {
      if (!row.conditions[0] || !row.conditions[0].condition.attributeParent) {
        return;
      }
      const columnLength = row.conditions.length - 1;
      if (columnLength !== 1 && rowLength >= 1) {
        tokens.push(Constants.OPENING_BRACE);
      }
      row.conditions.forEach((columnData, columnIndex) => {
        if (!columnData.condition.attributeParent) {
          return;
        }
        tokens.push(columnData.condition);
        if (columnLength !== columnIndex + 1) {
          tokens.push(columnData.logicalConnector);
        }
      });
      if (columnLength !== 1 && rowLength >= 1) {
        tokens.push(Constants.CLOSING_BRACE);
      }
      if (index + 1 !== rowLength) {
        tokens.push(row.logicalConnector);
      }
    });
    return tokens;
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/common/rule-preview/rule-preview.component.ts